import React from 'react';
import {
  styled,
} from '@mui/material/styles';
import MuiAppBar,
{ AppBarProps as MuiAppBarProperties } from '@mui/material/AppBar';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import Toolbar from '@mui/material/Toolbar';
import PropTypes, { InferProps } from 'prop-types';

const drawerWidth = 240;

interface AppBarProperties extends MuiAppBarProperties {
  open?: boolean;
}

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (property) => property !== 'open',
})<AppBarProperties>(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(['width', 'margin'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const StyledToolbar = styled(Toolbar)`
  background-color: #4F5F6F;

  svg path {
    fill: #fff;
  }
`;

const ToolbarContent = styled('div')`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  align-items: center;

  svg {
    flex: 1;
  }
`;

const StyledIconButton = styled(IconButton)<{ open: boolean }>`
  margin-right: 5px;
  display: flex;
  opacity: ${({ open }) => (open ? 0 : 1)};
`;

const topAppBarProperties = {
  logo: PropTypes.node,
  onToggleDrawer: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  userTab: PropTypes.node.isRequired,
};

type TopAppBarProperties = InferProps<typeof topAppBarProperties>;

const TopAppBar = ({
  logo, onToggleDrawer, open, userTab,
} : TopAppBarProperties) => (
  <AppBar position="fixed" open={open}>
    <StyledToolbar>
      <ToolbarContent>
        <StyledIconButton
          aria-label="open drawer"
          color="inherit"
          edge="start"
          onClick={onToggleDrawer}
          open={open}
        >
          <MenuIcon />
        </StyledIconButton>
        {logo}
        {userTab}
      </ToolbarContent>
    </StyledToolbar>
  </AppBar>
);

TopAppBar.propTypes = topAppBarProperties;

export default TopAppBar;
